// getRecurringPaymentMethods returns the list of recurring payment methods for the customer
export const PaymentsService_getRecurringPaymentMethodsLazy = () =>
  import("./payments_service.grpc").then(
    (m) => m.PaymentsService_getRecurringPaymentMethods
  );
PaymentsService_getRecurringPaymentMethodsLazy.method =
  "payments.v1.PaymentsService/getRecurringPaymentMethods" as const;

// updateRecurringPaymentInfo updates the recurring payment information. This also applies only for COD enabled countries
//
// In case the endpoint returns an `codes.InvalidArgument`, the error details contain a `google.rpc.BadRequest` message describing the fields that failed.
export const PaymentsService_updateRecurringPaymentInfoLazy = () =>
  import("./payments_service.grpc").then(
    (m) => m.PaymentsService_updateRecurringPaymentInfo
  );
PaymentsService_updateRecurringPaymentInfoLazy.method =
  "payments.v1.PaymentsService/updateRecurringPaymentInfo" as const;

// deleteRecurringPayment deletes a given payment method
export const PaymentsService_deleteRecurringPaymentLazy = () =>
  import("./payments_service.grpc").then(
    (m) => m.PaymentsService_deleteRecurringPayment
  );
PaymentsService_deleteRecurringPaymentLazy.method =
  "payments.v1.PaymentsService/deleteRecurringPayment" as const;

// createRecurringPaymentMethod creates a new recurring payment method (currently limited to bank accounts)
// (via a specific order, but the data is stored on the customer as a whole)
// If the customer already has a bank account as a "recurring payment method" (even if just for COD reimbursements), use `updateRecurringPaymentInfo` instead
export const PaymentsService_createRecurringPaymentMethodLazy = () =>
  import("./payments_service.grpc").then(
    (m) => m.PaymentsService_createRecurringPaymentMethod
  );
PaymentsService_createRecurringPaymentMethodLazy.method =
  "payments.v1.PaymentsService/createRecurringPaymentMethod" as const;

// setRefundBankAccount sets (creates or updates) the customer's bank account used for COD refunds
export const PaymentsService_setRefundBankAccountLazy = () =>
  import("./payments_service.grpc").then(
    (m) => m.PaymentsService_setRefundBankAccount
  );
PaymentsService_setRefundBankAccountLazy.method =
  "payments.v1.PaymentsService/setRefundBankAccount" as const;

// create a gift card refund request.
export const PaymentsService_createGiftCardRefundLazy = () =>
  import("./payments_service.grpc").then(
    (m) => m.PaymentsService_createGiftCardRefund
  );
PaymentsService_createGiftCardRefundLazy.method =
  "payments.v1.PaymentsService/createGiftCardRefund" as const;
